<kt-base-modal [title]="'End Loop'">
    <div modal-body>
      <kt-loader [showLoader]="loading()">

      <div>
        <google-map *ngIf="mapReady() && location.latitude" class="d-block w-100" height="400px" width="100%"
          [center]="{ lat: location.latitude, lng: location.longitude }" [zoom]="18"
          [options]="{ streetViewControl: false }">
          <map-marker [position]="{ lat: location.latitude, lng: location.longitude }"
            [options]="{ draggable: false, icon: defaultEnum.LOCATION_ICON_URL }">
          </map-marker>
          <map-marker *ngIf="this.shiftDetails"
            [position]="{ lat: (+this.shiftDetails.area.area_latitude), lng: (+this.shiftDetails.area.area_longitude) }"
            [options]="{ draggable: false }">
          </map-marker>
        </google-map>
        <div class="h5 text-center bg-light p-3 my-3">
          Distance From Actual Location {{distanceFromActualLocation | number : '1.2-2'}} KMs
        </div>
      </div>
      <div class="d-flex  justify-content-between">
        <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
        </kt-button>
        <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" (buttonClick)="endLoopHandler()">
        </kt-button>
      </div>
    </kt-loader>

    </div>

</kt-base-modal>